import {createContext} from 'react';

// Initialize and create context
export const LanguageContext = createContext(null);